import React from 'react';
import { Formik } from 'formik';

import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import InputLabel from '@RHEnvironmental/pattern-library/dist/js/components/InputLabel';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import InputField from '@RHEnvironmental/pattern-library/dist/js/components/InputField';

import { responseErrorFormatter } from '../../../services/http/errors';
import userApi from '../../../services/api/userApi';

const SignUpByInvite = ({ onSuccess, invite, token, emailExists }) => {
    const initialFormValues = {
        first_name: '',
        last_name: '',
        email: invite.email,
        email_exists: emailExists,
        token,
    };

    const initialFormStatus = {
        errors: {},
    };

    const onSubmit = async (
        values,
        { setSubmitting, setStatus, resetForm }
    ) => {
        try {
            const {
                data: { data },
            } = await userApi.createByInvite(values);
            onSuccess(data);
        } catch ({ response }) {
            setStatus({
                errors: responseErrorFormatter(response.data.errors),
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={initialFormValues}
            initialStatus={initialFormStatus}
        >
            {({ values, status, handleChange, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                    <InputContainer>
                        <InputLabel htmlFor="email" show>
                            Email
                        </InputLabel>
                        <InputField
                            id="email"
                            onChange={handleChange}
                            value={values.email}
                            aria-required="true"
                            errors={status.errors.email}
                            disabled
                            name="email"
                            type="email"
                        />
                    </InputContainer>
                    {!emailExists && (
                        <>
                            <InputContainer>
                                <InputLabel htmlFor="password" show>
                                    Password
                                </InputLabel>
                                <InputField
                                    id="password"
                                    onChange={handleChange}
                                    value={values.password}
                                    aria-required="true"
                                    errors={status.errors.password}
                                    name="password"
                                    type="password"
                                />
                            </InputContainer>
                            <InputContainer>
                                <InputLabel htmlFor="first_name" show>
                                    First name
                                </InputLabel>
                                <InputField
                                    id="first_name"
                                    onChange={handleChange}
                                    value={values.first_name}
                                    aria-required="true"
                                    errors={status.errors.first_name}
                                    name="first_name"
                                    type="text"
                                />
                            </InputContainer>
                            <InputContainer>
                                <InputLabel htmlFor="last_name" show>
                                    Last name
                                </InputLabel>
                                <InputField
                                    id="last_name"
                                    onChange={handleChange}
                                    value={values.last_name}
                                    aria-required="true"
                                    errors={status.errors.last_name}
                                    name="last_name"
                                    type="text"
                                />
                            </InputContainer>
                        </>
                    )}
                    <Button type="submit" disabled={isSubmitting}>
                        Sign Up
                    </Button>
                </form>
            )}
        </Formik>
    );
};

export default SignUpByInvite;
